import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Destroyer } from 'src/app/core/abstract/destroyer';

@Component({
  selector: 'craft-sidebar-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
  standalone: false,
})
export class SidebarSubMenuComponent extends Destroyer implements OnChanges {
  @Input() public name: string;
  @Input() public isActive = true;
  @Input() public isCollapsed = true;

  constructor() {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isActive && changes.isActive.isFirstChange()) {
      this.isCollapsed = !changes.isActive.currentValue;
    }
  }
}
